"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExperienceToDayDuration = exports.getDefaultFiltersForNeed = exports.DEFAULT_FILTERS_FOR_NEED = exports.DEFAULT_FILTERS_KEYS_FOR_NEED = void 0;
exports.buildWorkerSearchFiltersFromNeedDefaults = buildWorkerSearchFiltersFromNeedDefaults;
const lib_document_wrapper_logic_1 = require("@backend/lib-document-wrapper-logic");
const DAYS_PER_YEAR = 365;
exports.DEFAULT_FILTERS_KEYS_FOR_NEED = [
    'excludeHasIziStop',
    'excludeHasOnGoingShift',
    'radius',
    'needQualifStatus',
];
exports.DEFAULT_FILTERS_FOR_NEED = [
    { id: 'excludeHasIziStop', value: 'true' },
    { id: 'excludeHasOnGoingShift', value: 'true' },
    {
        id: 'needQualifStatus',
        value: 'NOT_QUALIFIED;PRESELECTED;PRESELECTED_INTERESTED;RECOMMENDED;TO_CALL',
    },
];
const getDefaultFiltersForNeed = (need, defaultFilterValues) => {
    if (!need)
        return undefined;
    const needJobs = [need.job.id, ...(need.relevantJobs ?? [])].filter(Boolean);
    if (!needJobs.length)
        return undefined;
    const { location, requiredCertificates, requiredExperience, requiredCertificatesLogicalOperator } = need;
    const { minDuration, maxDuration } = (0, exports.transformExperienceToDayDuration)(requiredExperience);
    const filteredCertificates = requiredCertificates?.length
        ? requiredCertificates.filter(value => !(0, lib_document_wrapper_logic_1.isCertificateLowFillRateAndShouldBeExcludedFromFilter)(value))
        : [];
    const result = [
        ...exports.DEFAULT_FILTERS_FOR_NEED,
        { id: 'radius', value: (need.workerSearchRadius ?? defaultFilterValues.radius).toString() },
        { id: 'city', value: location.city },
        { id: 'country', value: location.country },
        { id: 'stateShort', value: location.state },
        { id: 'latitude', value: location.coordinates?.[1].toString() },
        { id: 'longitude', value: location.coordinates?.[0].toString() },
        { id: 'postalCode', value: location.postalCode },
        { id: 'jobs', value: needJobs.join(';') },
        { id: 'certificatesLogicalOperator', value: requiredCertificatesLogicalOperator },
    ];
    if (location.district) {
        result.push({ id: 'district', value: location.district });
    }
    if (filteredCertificates.length) {
        result.push({ id: 'certificates', value: filteredCertificates.join(';') });
    }
    if (minDuration) {
        result.push({ id: 'minDuration', value: minDuration });
    }
    if (maxDuration) {
        result.push({ id: 'maxDuration', value: maxDuration });
    }
    if (need.workerSearchQuery) {
        result.push({ id: 'userCvInfo', value: need.workerSearchQuery });
    }
    if (need.requiredExperience !== 'NO_EXP_REQUIRED') {
        result.push({ id: 'recency', value: (2 * DAYS_PER_YEAR).toString() });
    }
    return result;
};
exports.getDefaultFiltersForNeed = getDefaultFiltersForNeed;
function buildWorkerSearchFiltersFromNeedDefaults(defaultFilterList, needId) {
    const findValue = (id) => defaultFilterList.find(filter => filter.id === id)?.value;
    const toNumber = (value) => (value ? Number(value) : undefined);
    const jobFilter = findValue('jobs');
    const certificateFilter = findValue('certificates');
    const needQualifStatus = findValue('needQualifStatus')?.split(';');
    return {
        excludeHasIziStop: findValue('excludeHasIziStop') === 'true' ? true : undefined,
        excludeHasOnGoingShift: findValue('excludeHasOnGoingShift') === 'true' ? true : undefined,
        userCvInfo: findValue('userCvInfo') ?? undefined,
        location: {
            geopoint: {
                lat: toNumber(findValue('latitude')) ?? 0,
                lon: toNumber(findValue('longitude')) ?? 0,
            },
            distance: toNumber(findValue('radius')) ?? 0,
        },
        ...(needQualifStatus?.length && { needQualifReports: { needId, status: needQualifStatus } }),
        ...(jobFilter
            ? {
                experiences: {
                    jobs: jobFilter.split(';'),
                    minDuration: toNumber(findValue('minDuration')),
                    maxDuration: toNumber(findValue('maxDuration')),
                    recency: toNumber(findValue('recency')),
                },
            }
            : {}),
        ...(certificateFilter
            ? {
                certificates: {
                    documentType: certificateFilter.split(';'),
                    excludeValidationStatus: ['BLOCKED', 'INVALID'],
                    logicalOperator: findValue('certificatesLogicalOperator') ?? undefined,
                },
            }
            : {}),
    };
}
const transformExperienceToDayDuration = (requiredExperience) => {
    switch (requiredExperience) {
        case 'NO_EXP_REQUIRED':
            return {};
        case 'ANY_REQUIRED':
            return { minDuration: '1' };
        case 'ONE_MONTH_REQUIRED':
            return { minDuration: '30' };
        case 'THREE_MONTHS_REQUIRED':
            return { minDuration: '90' };
        case 'SIX_MONTHS_REQUIRED':
            return { minDuration: (DAYS_PER_YEAR / 2).toString() };
        case 'ONE_YEAR_REQUIRED':
            return { minDuration: DAYS_PER_YEAR.toString() };
        case 'TWO_FIVE_YEARS_REQUIRED':
            return { minDuration: (2 * DAYS_PER_YEAR).toString(), maxDuration: (5 * DAYS_PER_YEAR).toString() };
        case 'FIVE_PLUS_YEARS_REQUIRED':
            return { minDuration: (5 * DAYS_PER_YEAR).toString() };
        default:
            return {};
    }
};
exports.transformExperienceToDayDuration = transformExperienceToDayDuration;
